var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-vertical",
          style: { "border-right-color": _vm.backgroundColor },
          attrs: {
            "default-active": _vm.activeIndex,
            "text-color": _vm.textColor,
            "background-color": _vm.backgroundColor,
            "active-text-color": _vm.activeTextColor,
            collapse: _vm.collapse,
            "unique-opened": ""
          },
          on: { select: _vm.menuSelect }
        },
        [
          _vm._l(_vm.items, function(item, index) {
            return [
              item.children.length <= 0
                ? _c(
                    "el-menu-item",
                    {
                      key: index,
                      staticClass: "menu-item-defalt",
                      class: {
                        "menu-item-select": _vm.activeIndex == item.path
                      },
                      attrs: { index: item.path }
                    },
                    [
                      _c("i", {
                        staticClass: "wukong",
                        class: item.meta.icon,
                        style: {
                          color:
                            _vm.activeIndex == item.path
                              ? _vm.activeTextColor
                              : _vm.textColor
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _vm._v(_vm._s(item.meta.title))
                      ]),
                      _vm._v(" "),
                      item.meta.num && item.meta.num > 0
                        ? _c("el-badge", {
                            attrs: { max: 99, value: item.meta.num }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _c(
                    "el-submenu",
                    { key: index, attrs: { index: item.path } },
                    [
                      !item.hidden
                        ? _c("template", { slot: "title" }, [
                            _c("i", {
                              staticClass: "wukong",
                              class: item.meta.icon
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { attrs: { slot: "title" }, slot: "title" },
                              [_vm._v(_vm._s(item.meta.title))]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(item.children, function(subitem, subindex) {
                        return _c(
                          "el-menu-item",
                          {
                            key: subindex,
                            staticClass: "menu-item-defalt",
                            class: {
                              "menu-item-select":
                                _vm.activeIndex == subitem.path
                            },
                            attrs: { index: subitem.path }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(subitem.meta.title) +
                                "\n        "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar-bottom",
          style: { "background-color": _vm.backgroundColor }
        },
        [
          _c("div", { staticClass: "sidebar-container" }, [
            _c("img", {
              staticClass: "collapse-button",
              style: { right: _vm.buttonNameCollapse ? "3px" : "0" },
              attrs: { src: _vm.bottom_icon_url },
              on: { click: _vm.toggleSideBarClick }
            })
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }